<template>
  <nav class="s-button-list">
    <ul class="s-button-list__list">
      <li v-for="index in itemCount" :key="index" class="s-button-list__item">
        <SButtonSkeleton size="sm" />
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import SButtonSkeleton from "@/atoms/SButtonSkeleton.vue";

withDefaults(
  defineProps<{
    itemCount?: number;
  }>(),
  {
    itemCount: 12,
  },
);
</script>
